<template>
  <el-container class="index-main">
    <el-main>
      <div>这是一个网页啦</div>
      <mouseMove />
    </el-main>
    <el-footer>
      <el-link href="https://beian.miit.gov.cn" type="primary" target="_blank">琼ICP备2021009120号</el-link>
    </el-footer>
  </el-container>
</template>

<script>
import mouseMove from '@/components/mouse-move.vue'
export default {
  name: 'Home',
  components: {
    mouseMove
  },
  methods: {
    mouseMove() {
    }
  }
}
</script>

<style scoped lang="scss">
.index-main{
  width: 100%;
  height: 100vh;
  text-align: center;
}
.el-main {
  background-color: #E9EEF3;
  color: #333;
}
.el-footer{

}
</style>
